import React from 'react';

import img1 from "../../assets/images/ladders/environment4.JPG";
import img2 from "../../assets/images/ladders/environment5.JPG";
import img3 from "../../assets/images/ladders/environment2.JPG";
import img4 from "../../assets/images/ladders/environment3.JPG";
import img5 from "../../assets/images/ladders/environment1.JPG";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const Hero = () => {
    return (
        <>
          <section className="py-5 md:10 lg:py-12 relative overflow-hidden flex items-center justify-center">
            <div className="container mx-auto px-3">
              <div className="relative">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center" data-aos="zoom-in">
                  <div className="max-w-xl">
                    <span className="py-1 px-3 rounded-md md:text-lg font-semibold tracking-wider text-[#E66A22]">
                      Your Safety, Our Priority
                    </span>
                    <h2 className="md:text-4xl/tight text-2xl font-semibold my-5">
                      Crafting Durable and Reliable Aluminium Ladders for Every Need
                    </h2>
                    <p className="text-sm md:text-base tracking-wide mb-10 text-gray-600">
                      At Yogesh Aluminium Ladder Manufacturing, we build ladders you
                      can trust—strong, safe, and built to last. Whether for home or
                      industry, we've got you covered."
                    </p>
                  </div>
                        <div>
                          <Swiper
                            modules={[Autoplay, Pagination]}
                            autoplay={{
                              delay: 3000, // Time delay between slides (in ms)
                              disableOnInteraction: false, // Keeps autoplay active after user interaction
                            }}
                            // pagination={{ clickable: true }}
                            loop={true} // Makes the slider loop infinitely
                            className="h-full "
                          >
                            <SwiperSlide>
                              <div className="swiper-slide relative ">
                                <img
                                  src={img1}
                                  className="h-[300px] md:h-[550px] xl:[600px] rounded-xl w-full "
                                  alt="Slide 1"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="swiper-slide relative ">
                                <img
                                  src={img2}
                                  className="h-[300px] md:h-[550px] xl:[600px] rounded-xl w-full "
                                  alt="Slide 2"
                                />
                              </div>
                            </SwiperSlide>
                            <SwiperSlide>
                              <div className="swiper-slide relative ">
                                <img
                                  src={img3}
                                  className="h-[300px] md:h-[550px] xl:[60px] w-full "
                                  alt="Slide 3"
                                />
                              </div>
                            </SwiperSlide>
    
                            <SwiperSlide>
                              <div className="swiper-slide relative ">
                                <img
                                  src={img4}
                                  className="h-[300px] md:h-[550px] xl:[600px] rounded-xl w-full "
                                  alt="Slide 4"
                                />
                              </div>
                            </SwiperSlide>
    
                            <SwiperSlide>
                              <div className="swiper-slide relative ">
                                <img
                                  src={img5}
                                  className="h-[300px] md:h-[550px] xl:[600px] rounded-xl w-full "
                                  alt="Slide 5"
                                />
                              </div>
                            </SwiperSlide>
                          </Swiper>
                        </div>
                      
                </div>
              </div>
            </div>
          </section>
        </>
      );
}

export default Hero



